import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../../config';
import { Http,Headers } from '@angular/http';
import { IcbService } from '../../icb.service'
import { ErrorHandler } from '../../../shared/services/error-handler.service'
import { HttpService } from '../../../shared/services/http.service'
import { LayoutService } from '../../../layout/layout.service'
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder, FormControl, Validators,FormsModule  } from '@angular/forms';
import { itemClass,itemClassEdit } from './itemClass';
import { MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../../../dialog/dialog.component';

@Component({
    selector: 'request-add',
    template: require('./summary.component.html'),
    styles: [require('./summary.component.scss')],
    providers: [HttpService, ErrorHandler,SessionHandler,IcbService]
})

export class t2tSummaryComponent {
    t2tFormData:any= {};
    dialogRef;
    requestFormData:any = {};
    userData:any;
    tradeId:any;
    tradeData:any = {};
	constructor(private router: Router,private route: ActivatedRoute,private Http: Http,private http:HttpService,private formBuilder: FormBuilder, private commonService : CommonService,private sessionHandler:SessionHandler,
    private dialog: MdDialog) {

        if(this.http.checkSession()){
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.tradeId = this.userData.tradePartnerId;
            let data = this.commonService.getData();
            if(data && data['icbRequest']) {
                this.t2tFormData = data['icbRequest'];
                console.log(this.t2tFormData);
            } else {
                this.router.navigateByUrl('/app/icb/trade/data');
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() {}

    public goToNextPage() {
        this.http.postRequest(this.t2tFormData,'serviceOrder/v1/saveServiceOrderWithSap').subscribe(
            res => {
                this.saveResponse(res);
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Submit Failed';

                }
                this.http.onEnd();
                }
            );
    }
    public saveResponse(res) {
        if(res.status == 'Success') {
            this.t2tFormData['soId'] = res.ServiceOrderId;
            this.commonService.setData(this.t2tFormData);
            this.router.navigateByUrl('/app/icb/trade/confirm');
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
        this.http.onEnd();
    }

    public goToPreviousPage() {
        this.router.navigateByUrl('/app/icb/trade/data');
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/t2t/summary/summary.component.ts